module.exports = __webpack_public_path__ + "frontend-assets/img/single-coupon.b82591b0.png";